import styled from "@emotion/styled";
import { Theme } from "@emotion/react";
import { MDSText } from "@/mds/components/text";
import { Button } from "react-aria-components";

// Define styles as a function that takes theme
const sharedStyles = (theme: Theme) => `
  display: block;

  border-radius: ${theme.borderRadius.mediumLarge}px;
  background: ${theme.colors.background.card.default};
  padding: ${theme.spacing.md};
  box-shadow: ${theme.shadows.surface};
  border: 1px solid ${theme.colors.border.default};
  transition: all 0.2s ease;

  &:disabled, &[disabled] {
    opacity: 0.4;
    cursor: not-allowed;
    box-shadow: none;
    border-color: ${theme.colors.border.default};
    background: ${theme.colors.background.card.default};
    transform: none;
    pointer-events: none;
  }
`;

export const StyledCard = styled.div`
  ${({ theme }) => sharedStyles(theme)}
`;

export const StyledButton = styled(Button)`
  ${({ theme }) => sharedStyles(theme)}
`;

export const StyledButtonContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: left;
  justify-content: left;
  gap: ${({ theme }) => theme.spacing.sm};
`;

export const StyledCardHeader = styled.div`
  display: flex;
  align-items: left;
  gap: ${({ theme }) => theme.spacing.smd};
`;

export const StyledCardIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.grey.x500};
  & svg {
    font-size: ${({ theme }) => theme.fontSizes.large};
  }
  margin-left: 2px;
`;

export const StyledCardTitle = styled(MDSText)`
  margin: 0;
  font-size: ${({ theme }) => theme.fontSizes.large};
  font-weight: ${({ theme }) => theme.fontWeights.semiBold};
  line-height: ${({ theme }) => theme.lineHeights.large};
  text-align: left;
  flex: 1;
`;

export const StyledCardRightAddon = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.xs};
  font-size: ${({ theme }) => theme.fontSizes.small};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  color: ${({ theme }) => theme.colors.grey.x600};
`;

export const StyledCardDescription = styled(MDSText)`
  line-height: ${({ theme }) => theme.lineHeights.xsmall};
  text-align: left;
  text-wrap: wrap;
`;

export const StyledCardContent = styled.div`
  display: flex;
  flex-direction: column;
  font-size: ${({ theme }) => theme.fontSizes.medium};
  font-weight: ${({ theme }) => theme.fontWeights.regular};
  color: ${({ theme }) => theme.colors.grey.x600};
  text-align: left;
`;
